import StaffPickImageProvider from '@components/StaffPickImageProvider'

export const withStaffPickImage = (WrappedComponent: any) => {
  return function (props: any) {
    return (
      <StaffPickImageProvider>
        <WrappedComponent {...props} />
      </StaffPickImageProvider>
    )
  }
}
